import { render, staticRenderFns } from "./ResultImportServerTable.vue?vue&type=template&id=ca092f0a"
import script from "./ResultImportServerTable.vue?vue&type=script&lang=js"
export * from "./ResultImportServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports